(() => {
  if (window.mpSavingsLoaderBound) return;
  window.mpSavingsLoaderBound = true;
  let loading;
  const load = () => {
    if (customElements.get('mp-product-savings')) return;
    if (loading) return loading;
    const component = document.querySelector('mp-product-savings[data-savings-script]');
    if (!component) return;
    const src = component.dataset.savingsScript;
    loading = new Promise((resolve) => {
      if ([...document.scripts].some(script => script.src === src)) return resolve();
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', () => {
        script.remove();
        loading = null;
        resolve();
      }, { once: true });
      document.head.append(script);
    });
    return loading;
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    if (!entries.some(entry => entry.isIntersecting)) return;
    observer.disconnect();
    load();
  }, { rootMargin: '600px 0px' }) : null;
  const scan = () => {
    document.querySelectorAll('mp-product-savings[data-savings-script]').forEach(component => {
      if (observer) observer.observe(component);
      else load();
    });
  };
  document.addEventListener('mp:savings-load', load);
  document.addEventListener('focusin', event => {
    if (event.target.closest?.('mp-product-savings')) load();
  });
  document.addEventListener('pointerdown', event => {
    if (event.target.closest?.('mp-product-savings')) load();
  }, { passive: true });
  document.addEventListener('shopify:section:load', scan);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
})();
